import * as ACTIONTYPES from '../constants/actiontypes';
import 'whatwg-fetch';
import AppApiUrl from '../../api/AppApiUrl';
import screenfull from 'screenfull';
import { isMobile, isMobileOnly } from "react-device-detect";

import {
  fetchBook
} from './data-fetching-actions';


export const togglePlay = (isPlaying) => (dispatch, getState) => {

  const { viewMode } = getState();
  const { isFullscreen } = getState().videoPlayerState;
  const isWidget = !!getState().app.isWidget;
  const currIsPlaying = getState().videoPlayerState.isPlaying;

  // if modes are different - change play/pause
  if (isPlaying !== currIsPlaying) {
    if (!isFullscreen && isMobile && isWidget && viewMode !== 'text') {
      dispatch(onClickFullscreen());
    }

    // if(viewMode !== 'text') {
      dispatch({
        type: ACTIONTYPES.CHANGE_PLAY_MODE,
        isPlaying
      });
    // }
  }
};

export const toggleLoginPopup = (visibility) => ({
  type: ACTIONTYPES.TOGGLE_LOGIN_POPUP,
  isVisible: visibility,
});


export const toggleTextSettings = (isVisible) => ({
  type: ACTIONTYPES.TOGGLE_TEXT_SETTINGS,
  isVisible
});


export const showUnavailablePopup = () => {
  return {
    type: ACTIONTYPES.UNAVAILABLE_POPUP_SHOW,
    show: true
  }
};

export const toggleFullscreen = (val) => (dispatch, getState) => {
  const state = getState();
  const { isFullscreen } = state.videoPlayerState;
  const isWidget = !!state.app.isWidget;

  if (isFullscreen && isMobile && isWidget) {
    dispatch(togglePlay(false))
  }

  dispatch({
    type: ACTIONTYPES.TOGGLE_FULL_SCREEN,
    isActive: val,
  });

  if (!val) {
    screenfull.exit();
  } else {
    screenfull.request(document.querySelector(state.app.parentSelector));
    if (isMobileOnly) {
      window.screen.orientation.lock('landscape');
    }
  }

};


export const toggleTextPlayerTheme = (action) => {
  return ({
    type: ACTIONTYPES.TEXT_PLAYER_CHANGE_THEME,
    data: action,
  })
};


export const changeVideoResolution = (resolution = 1080) => (dispatch, getState) => {
  const guid = getState().book.bookInfo.GUID;
  const bookUrl = AppApiUrl.getBookInfoUrl({ guid: guid, resolution });

  dispatch(fetchBook(bookUrl));

  dispatch({
    type: ACTIONTYPES.CHANGE_VIDEO_RESOLUTION,
    resolution
  });
}


export const changeTextAreaPage = (page, pages) => ({
  type: ACTIONTYPES.CHANGE_TEXT_AREA_PAGE,
  page,
  pages
});

export const changePlaybackRate = (playbackRate) => {
  return ({
    type: ACTIONTYPES.CHANGE_PLAYBACK_RATE,
    playbackRate
  })
};

export const onClickFullscreen = () => (dispatch, getState) => {
  const state = getState();
  const isFullscreen = state.videoPlayerState.isFullscreen;

  const escFunction = () => {
    if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      window.removeEventListener('webkitfullscreenchange', escFunction, false);
      window.removeEventListener('mozfullscreenchange', escFunction, false);
      window.removeEventListener('fullscreenchange', escFunction, false);
      window.removeEventListener('MSFullscreenChange', escFunction, false);
      if (getState().videoPlayerState.isFullscreen) {
        dispatch(toggleFullscreen(false));
      }
    }
  }

  if (isFullscreen) {
    window.removeEventListener('webkitfullscreenchange', escFunction, false);
    window.removeEventListener('mozfullscreenchange', escFunction, false);
    window.removeEventListener('fullscreenchange', escFunction, false);
    window.removeEventListener('MSFullscreenChange', escFunction, false);
    // screenfull.off('change', escFunction)
  } else {
    // screenfull.onchange(escFunction)
    window.addEventListener('webkitfullscreenchange', escFunction, false);
    window.addEventListener('mozfullscreenchange', escFunction, false);
    window.addEventListener('fullscreenchange', escFunction, false);
    window.addEventListener('MSFullscreenChange', escFunction, false);
  }

  dispatch(toggleFullscreen(!isFullscreen));
};

export const setTextHeight = (height) => {
  return ({
    type: ACTIONTYPES.SET_TEXT_HEIGHT,
    data: height
  })
};



// WEBPACK FOOTER //
// ./src/store/actions/index.js